/* Experiencia "medidas a escala": la foto real del producto, a su tamaño real en cm, junto a un objeto de referencia
   de la casa (con sus medidas típicas, rotuladas). Arrastra la referencia para comparar.
   Datos: { "tipo": "medidas", "foto": 1, "caja": [x0,y0,x1,y1] (% de la foto donde está el producto; opcional),
            "alto": 25, "ancho": 6.5, "fondo": 6.5 (o "diametro"), "referencias": ["celular","botella"],
            "por_variante": { "65 cm": { "ancho": 65, "alto": 52 } } }
   Si no trae medidas usa nayhogar.medidas. */
(function () {
  // Objetos de referencia con medidas típicas (cm). Dibujos simples en SVG con su caja = alto x ancho.
  const REF = {
    taza: { n: 'Taza', alto: 9.5, ancho: 12, d: '<path d="M8 4h68v70a14 14 0 0 1-14 14H22A14 14 0 0 1 8 74z"/><path d="M76 22h10a14 14 0 0 1 0 28H76" fill="none" stroke="currentColor" stroke-width="8"/>', vb: '0 0 100 88' },
    celular: { n: 'Celular', alto: 15, ancho: 7.2, d: '<rect x="1" y="1" width="70" height="148" rx="11"/><rect x="6" y="9" width="60" height="128" rx="5" fill="#fff" opacity=".35"/>', vb: '0 0 72 150' },
    lata: { n: 'Lata de 330 ml', alto: 12.2, ancho: 6.6, d: '<path d="M8 6h50l4 6v98l-4 6H8l-4-6V12z"/><rect x="4" y="40" width="58" height="34" fill="#fff" opacity=".3"/>', vb: '0 0 66 122' },
    botella: { n: 'Botella de 1,5 L', alto: 31, ancho: 9, d: '<path d="M33 0h24v18c0 8 26 22 26 48v226c0 10-6 18-14 18H21c-8 0-14-8-14-18V66C7 40 33 26 33 18z"/><rect x="7" y="120" width="76" height="60" fill="#fff" opacity=".3"/>', vb: '0 0 90 310' },
    hoja: { n: 'Hoja carta', alto: 27.9, ancho: 21.6, d: '<rect x="0" y="0" width="216" height="279" rx="4"/><path d="M28 50h160M28 80h160M28 110h120" stroke="#fff" stroke-width="6" opacity=".45"/>', vb: '0 0 216 279' },
    silla: { n: 'Silla de comedor', alto: 90, ancho: 45, d: '<path d="M60 0h330v470H60z"/><path d="M30 460h390v50H30z"/><path d="M50 500h40v400H50zM360 500h40v400h-40z"/>', vb: '0 0 450 900' },
    persona: { n: 'Persona de 1,60 m', alto: 160, ancho: 46, d: '<circle cx="230" cy="110" r="100"/><path d="M80 260h300a60 60 0 0 1 60 60v520h-80V560h-20v1040h-110V1000h-40v600H80V560H60v280H20V320a60 60 0 0 1 60-60z"/>', vb: '0 0 460 1600' },
    puerta: { n: 'Puerta', alto: 200, ancho: 80, d: '<path d="M0 0h800v2000H0z"/><path d="M60 60h680v1880H60z" fill="#fff" opacity=".25"/><circle cx="660" cy="1000" r="26" fill="#fff" opacity=".6"/>', vb: '0 0 800 2000' }
  };
  function elegirRefs(m) {
    const max = Math.max(m.alto || 0, m.ancho || 0);
    if (max <= 20) return ['taza', 'celular', 'lata'];
    if (max <= 45) return ['celular', 'botella', 'hoja'];
    if (max <= 100) return ['botella', 'hoja', 'silla'];
    if (max <= 170) return ['silla', 'persona'];
    return ['persona', 'puerta'];
  }

  NHX.registrar('medidas', function (root, d, x) {
    const P = x.producto();
    const base = x.medidas(d) || x.medidas(P.medidas);
    if (!base || !(base.alto || base.diametro) || !(base.ancho || base.diametro)) return false;
    const f = x.foto(d.foto || 1);
    if (!f) return false;
    // medidas por variante (opcional): chips para cambiar, sincronizados con la compra
    const pv = d.por_variante && typeof d.por_variante === 'object' ? d.por_variante : null;
    const nombresPV = pv ? Object.keys(pv) : [];
    let m = Object.assign({}, base);
    let refs = (Array.isArray(d.referencias) ? d.referencias : elegirRefs(m)).filter(k => REF[k]);
    if (!refs.length) refs = elegirRefs(m);
    let ref = refs[0];

    root.innerHTML =
      '<div class="xme">' +
        '<div class="xme__stage nhx-stage">' +
          '<div class="xme__regla" aria-hidden="true"></div><div class="xme__piso" aria-hidden="true"></div>' +
          '<div class="xme__prod"><div class="xme__crop"><img class="nhx-prod" alt="" draggable="false"></div>' +
            '<span class="xme__cota xme__cota--alto"><i></i><b data-alto></b></span><span class="xme__cota xme__cota--ancho"><i></i><b data-ancho></b></span></div>' +
          '<div class="xme__ref" tabindex="0" role="img"><svg class="xme__svg" preserveAspectRatio="none" fill="currentColor"></svg><span class="xme__rn"></span></div>' +
          x.pista('Arrastra la referencia', 'mano') +
        '</div>' +
        '<div class="nhx-ctrls">' +
          (nombresPV.length > 1 ? '<div class="nhx-seg" role="group" aria-label="Tamaño" data-pv>' + nombresPV.map(n => '<button type="button" aria-pressed="false" data-v="' + x.esc(n) + '">' + x.esc(n) + '</button>').join('') + '</div>' : '') +
          '<div class="nhx-seg" role="group" aria-label="Comparar con" data-refs>' + refs.map(k => '<button type="button" aria-pressed="' + (k === ref) + '" data-r="' + k + '">' + x.esc(REF[k].n) + '</button>').join('') + '</div>' +
        '</div>' +
        '<dl class="xme__ficha nhx-in"></dl>' +
        (Array.isArray(base.extra) && base.extra.length ? '<ul class="xme__extra">' + base.extra.map(t => '<li>' + x.esc(t) + '</li>').join('') + '</ul>' : '') +
        '<p class="nhx-note">Medidas del fabricante. Los objetos de referencia tienen medidas típicas.</p>' +
      '</div>';
    const st = root.querySelector('.xme__stage'), prod = root.querySelector('.xme__prod'), crop = prod.querySelector('.xme__crop'), img = crop.querySelector('img');
    const rEl = root.querySelector('.xme__ref'), svg = rEl.querySelector('svg'), rn = rEl.querySelector('.xme__rn'), regla = root.querySelector('.xme__regla');
    const ficha = root.querySelector('.xme__ficha');
    img.src = f.src; img.alt = f.alt || P.titulo;
    let offset = null; // desplazamiento de la referencia (px) puesto por la clienta

    function caja() {
      if (Array.isArray(d.caja) && d.caja.length === 4) { const c = d.caja.map(Number); return { x0: c[0], y0: c[1], w: c[2] - c[0], h: c[3] - c[1] }; }
      // guía de fotos: el lado mayor del producto ocupa el 78 % de la foto, centrado
      const r = m.ancho / m.alto, L = 78;
      const w = r >= 1 ? L : L * r, h = r >= 1 ? L / r : L;
      return { x0: 50 - w / 2, y0: 50 - h / 2, w, h };
    }
    function pintar() {
      const W = st.clientWidth, H = st.clientHeight;
      const R = REF[ref];
      const gapCm = Math.max(m.ancho, R.ancho) * 0.35;
      const piso = H * 0.84;
      const s = Math.min((H * 0.66) / Math.max(m.alto, R.alto), (W * 0.74) / (m.ancho + R.ancho + gapCm));
      const pw = m.ancho * s, ph = m.alto * s, rw = R.ancho * s, rh = R.alto * s;
      const total = pw + gapCm * s + rw;
      const x0 = (W - total) / 2 + W * 0.03;
      // producto recortado de su foto a su tamaño real
      const c = caja();
      const fw = pw / (c.w / 100), fh = fw / (f.ar || 1);
      prod.style.cssText = 'left:' + x0 + 'px;top:' + (piso - ph) + 'px;width:' + pw + 'px;height:' + ph + 'px';
      img.style.cssText = 'width:' + fw + 'px;height:' + fh + 'px;left:' + (-c.x0 / 100 * fw) + 'px;top:' + (-c.y0 / 100 * fh) + 'px';
      // referencia
      svg.setAttribute('viewBox', R.vb); svg.innerHTML = R.d;
      const rx = offset == null ? x0 + pw + gapCm * s : x.clamp(offset, 8, W - rw - 8);
      rEl.style.cssText = 'left:' + rx + 'px;top:' + (piso - rh) + 'px;width:' + rw + 'px;height:' + rh + 'px';
      rEl.setAttribute('aria-label', R.n + ': ' + x.fmt(R.alto) + ' cm de alto');
      rn.innerHTML = '<b>' + x.esc(R.n) + '</b> ' + x.fmt(R.alto) + ' cm';
      rEl.classList.toggle('is-chica', rh < 70);
      // cotas
      prod.querySelector('[data-alto]').textContent = x.fmt(m.alto) + ' cm';
      prod.querySelector('[data-ancho]').textContent = x.fmt(m.ancho) + ' cm';
      prod.classList.toggle('is-chico', ph < 90 || pw < 60);
      // regla: marcas cada 1, 5, 10, 50 cm según la escala
      const maxCm = piso / s;
      const paso = [1, 2, 5, 10, 20, 50, 100].find(p => p * s >= 26) || 100;
      let marcas = '';
      for (let cm = 0; cm <= maxCm; cm += paso) marcas += '<span style="bottom:' + ((H - piso) + cm * s) + 'px"><i></i>' + (cm ? x.fmt(cm) : '0') + '</span>';
      regla.innerHTML = marcas;
      root.querySelector('.xme__piso').style.top = piso + 'px';
    }
    function pintarFicha() {
      const filas = [];
      if (m.alto) filas.push(['Alto', m.alto]);
      if (m.diametro) filas.push(['Diámetro', m.diametro]);
      else { if (m.ancho) filas.push(['Ancho', m.ancho]); }
      if (m.fondo && !m.diametro) filas.push(['Fondo', m.fondo]);
      ficha.innerHTML = filas.map(r => '<div><dt>' + r[0] + '</dt><dd>' + x.fmt(r[1]) + '<small>cm</small></dd></div>').join('') +
        (m.ml ? '<div><dt>Capacidad</dt><dd>' + (m.ml >= 1000 ? x.fmt(m.ml / 1000) + '<small>L</small>' : x.fmt(m.ml) + '<small>ml</small>') + '</dd></div>' : '') +
        (m.peso_txt ? '<div><dt>Peso</dt><dd>' + x.esc(m.peso_txt) + '</dd></div>' : '');
    }
    pintarFicha();
    // elegir referencia
    root.querySelectorAll('[data-r]').forEach(b => b.addEventListener('click', () => {
      ref = b.dataset.r; offset = null;
      root.querySelectorAll('[data-r]').forEach(y => y.setAttribute('aria-pressed', y === b));
      st.classList.add('is-cambio'); pintar(); setTimeout(() => st.classList.remove('is-cambio'), 450);
    }));
    // medidas por variante
    function ponerVariante(nombre, avisar) {
      if (!pv || !pv[nombre]) return;
      const mv = x.medidas(Object.assign({}, d, pv[nombre]));
      if (mv) { m = Object.assign({}, base, mv); }
      root.querySelectorAll('[data-v]').forEach(y => y.setAttribute('aria-pressed', y.dataset.v === nombre));
      pintar(); pintarFicha();
      if (avisar) { const i = P.opciones.findIndex((o, k) => P.variantes.some(v => v.opciones[k] === nombre)); if (i >= 0) x.seleccionar(i, nombre); }
    }
    root.querySelectorAll('[data-v]').forEach(b => b.addEventListener('click', () => ponerVariante(b.dataset.v, true)));
    if (pv) {
      x.alCambiarVariante(v => { const n = (v.options || []).find(o => pv[o]); if (n) ponerVariante(n, false); });
      const primera = nombresPV.find(n => P.variantes.length && P.variantes[0].opciones.indexOf(n) >= 0) || nombresPV[0];
      ponerVariante(primera, false);
    }
    // arrastrar la referencia
    let dx = 0;
    x.drag(rEl, {
      start: e => { st.classList.add('is-tocado'); rEl.classList.add('is-arrastre'); dx = e.clientX - rEl.getBoundingClientRect().left; },
      move: e => { const b = st.getBoundingClientRect(); offset = e.clientX - b.left - dx; pintar(); },
      end: () => rEl.classList.remove('is-arrastre')
    });
    rEl.addEventListener('keydown', e => { const k = { ArrowLeft: -12, ArrowRight: 12 }[e.key]; if (k) { e.preventDefault(); offset = (offset == null ? rEl.offsetLeft : offset) + k; pintar(); } });
    if ('ResizeObserver' in window) new ResizeObserver(() => pintar()).observe(st); else window.addEventListener('resize', pintar);
    pintar();
    x.alVer(st, () => st.classList.add('in'), 0.3);
  });
})();
